module.exports = __webpack_public_path__ + "static/media/spanish.c3a1309d.svg";